import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAirpods: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconAirpods"><Path d="M6 3C8.76142 3 11 5.23858 11 8V21H7V12.8994C6.67686 12.965 6.3425 13 6 13C4.36398 13 2.91219 12.2137 2 10.999V5C2.91221 3.78565 4.36426 3 6 3Z" fill="currentColor"/><Path d="M18 3C15.2386 3 13 5.23858 13 8V21H17V12.8994C17.3231 12.965 17.6575 13 18 13C19.636 13 21.0878 12.2137 22 10.999V5C21.0878 3.78565 19.6357 3 18 3Z" fill="currentColor"/></CentralIconBase>;
});

export default IconAirpods;
